/**
 * A simple function to simplify the code within the *Model classes
 *
 * @example
 * // without
 * this.debtId = Object.hasOwn(liability, 'debtId') ? liability.debtId : '';
 * // the ternary adds a point to the cognitive complexity score
 *
 * // with
 * this.debtId = getPropertyOr(liability, 'debtId', '');
 */
export function getPropertyOr<
  TObj extends Record<string, unknown>,
  TKey extends keyof TObj extends never ? string : keyof TObj,
>(
  obj: TObj,
  key: TKey,
  defaultValue: TObj[TKey],
): TObj[TKey] extends unknown ? any : TObj[TKey] {
  return Object.hasOwn(obj, key) ? obj[key] : defaultValue;
}

/**
 * Finds an object key by its value (inverse lookup)
 */
export function getKeyByValue<T extends Record<string, string | number>>(
  obj: T,
  value: string | number,
) {
  return Object.entries(obj).find(([, v]) => v === value)?.[0] as
    | keyof T
    | undefined;
}
